import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import {
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Box,
  Alert,
  AppBar,
  TablePagination,
  Toolbar,
  IconButton,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Autocomplete
} from '@mui/material'
import {
  Restaurant,
  ArrowBack,
  Save,
  Search,
  Person,
  Email,
  WhatsApp
} from '@mui/icons-material'

import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import ListItemText from '@mui/material/ListItemText';

import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import PropTypes from 'prop-types';

import { format, parseISO } from 'date-fns';

import Collapse from '@mui/material/Collapse';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { useAuth } from '../../contexts/AuthContext'
import api from '../../utils/axios'
import Form from './../../components/Form.css'

const Formprodutor = () => {
  const navigate = useNavigate()
  const { user, updateUser } = useAuth()
  console.log(user);

  const [rows, setRows] = useState([]);
  const [generosalimenticios, setGenerosalimenticios] = useState([]);
  const [selecionados, setSelecionados] = useState([]);
  const [alimentossalvos, setAlimentossalvos] = useState([]);
  const [gruposAssociacoes, setGruposAssociacoes] = useState([]);

  const [itemEdit, setItemEdit] = useState(null);

  const { register, handleSubmit, reset, formState: { errors } } = useForm({
    defaultValues: {
      nome: itemEdit?.nome || '',
      dtnascimento: itemEdit?.dtnascimento || '',
      cpf: itemEdit?.cpf || '',
      caf: itemEdit?.caf || '',
      data_inscricao_caf: itemEdit?.data_inscricao_caf || '',
      genero: itemEdit?.genero || '',
      apelido: itemEdit?.apelido || '',
      nmconjuge: itemEdit?.nmconjuge || '',
      telefone: itemEdit?.telefone || '',
      sitiopropriedade: itemEdit?.sitiopropriedade || '',
      localidadereferencia: itemEdit?.localidadereferencia || '',
      pontogeoreferencia: itemEdit?.pontogeoreferencia || '',
      areapropriedade: itemEdit?.areapropriedade || '',
      generosalimenticios: itemEdit?.generosalimenticios || '',
      idgrupo: itemEdit?.idgrupo || ''
      // data_inscricao_caf: user?.data_inscricao_caf
      //   ? new Date(user.data_inscricao_caf).toISOString().split('T')[0]
      //   : ''
    }
  })
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [loading, setLoading] = useState(false)

  //   const { row } = props;
  const [open, setOpen] = React.useState(false);

  const [mode, setMode] = useState('');
  const [emailDestinatario, setEmailDestinatario] = useState('');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    if (mode === "edit" && itemEdit) {
      reset(itemEdit); // <-- Aqui acontece a mágica
    } else if (mode === "create" || mode === "Busca" || !itemEdit) {
      console.log('resettttttt');
      const defaultValues = {
        nome: '',
        cpf: '',
        caf: '',
        data_inscricao_caf: '',
        idgrupo: ''
      };
      reset(defaultValues);
      setRows([]);
    }
  }, [itemEdit, reset, mode]);

  const handleEdit = async (item) => {
    console.log(item);
    setMode('edit');
    setItemEdit(item);
    reset(item);


    try {
      const response = await api.put('/produtorprodutos/list.php', {
        idprodutor: item.id,       
      })

      console.log(response.data.alimentos);

      if (response.data.success) {
        // const updatedUser = { ...user, ...data }
        // console.log(updateUser);
        setAlimentossalvos(response.data.alimentos);
        setSelecionados(response.data.alimentos.map((a) => a.idproduto));
        // updateUser(updatedUser)
        // setSuccess('Dados atualizados com sucesso!')
        // setTimeout(() => {
        //   navigate('/produtor')
        // }, 1500)
      } else {
        setError(response.data.message || 'Erro ao atualizar dados')
      }
    } catch (err) {
      setError(err.response?.data?.message || err)
    } finally {
      setLoading(false)
    }





    // if (eventos.length && eventosSalvos.length) {
    //   const selecionados = eventos.filter(e =>
    //     eventosSalvos.includes(e.id)
    //   );
    //   setEventosSelecionados(selecionados);
    // }

  }

  const onSubmit = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)


    console.log(data);
    console.log(mode);


    if (!data.id) {
      try {
        const response = await api.put('/produtor/save.php', {
          // id: data.id,
          nome: data.nome,
          dtnascimento: data.dtnascimento,
          cpf: data.cpf,
          caf: data.caf,
          data_inscricao_caf: data.data_inscricao_caf,
          genero: data.genero,
          apelido: data.apelido,
          nmconjuge: data.nmconjuge,
          telefone: data.telefone,
          sitiopropriedade: data.sitiopropriedade,
          localidadereferencia: data.localidadereferencia,
          pontogeoreferencia: data.pontogeoreferencia,
          areapropriedade: data.areapropriedade,
          generosalimenticios: selecionados,
          idgrupo: data.idgrupo || null,


        })

        if (response.data.success) {
          // const updatedUser = { ...user, ...data }
          // updateUser(updatedUser)
          setSuccess('Dados atualizados com sucesso!')
          // setTimeout(() => {
          //   navigate('/produtor')
          // }, 1500)
        } else {
          setError(response.data.message || 'Erro ao atualizar dados')
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao atualizar dados')
      } finally {
        setLoading(false)
      }
    } else {

      setMode('create');


      try {
        const response = await api.put('/produtor/update.php', {
          id: data.id,
          nome: data.nome,
          dtnascimento: data.dtnascimento,
          cpf: data.cpf,
          caf: data.caf,
          data_inscricao_caf: data.data_inscricao_caf,
          genero: data.genero,
          apelido: data.apelido,
          nmconjuge: data.nmconjuge,
          telefone: data.telefone,
          sitiopropriedade: data.sitiopropriedade,
          localidadereferencia: data.localidadereferencia,
          pontogeoreferencia: data.pontogeoreferencia,
          areapropriedade: data.areapropriedade,
          generosalimenticios: selecionados,
          idgrupo: data.idgrupo || null,
        })

        console.log(response);

        if (response.data.success) {
          const updatedUser = { ...user, ...data }
          updateUser(updatedUser)
          setSuccess('Dados atualizados com sucesso!')
          // setTimeout(() => {
          //   navigate('/produtor')
          // }, 1500)
        } else {
          setError(response.data.message || 'Erro ao atualizar dados')
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Erro ao atualizar dados')
      } finally {
        setLoading(false)
      }
    }
  }

  const onSubmitBusca = async (data) => {
    setError('')
    setSuccess('')
    setLoading(true)
    setMode('');
    setPage(0);

    console.log(data);


    try {
      const response = await api.put('/produtor/list.php', {
        id: user.id,
        nome: data.nome,
        cpf: data.cpf,
        caf: data.caf,
        data_inscricao_caf: data.data_inscricao_caf
      })

      console.log(response.data.produtores);

      if (response.data.success) {
        const updatedUser = { ...user, ...data }
        console.log(updateUser);
        setRows(response.data.produtores)
        // updateUser(updatedUser)
        // setSuccess('Dados atualizados com sucesso!')
        // setTimeout(() => {
        //   navigate('/produtor')
        // }, 1500)
      } else {
        setError(response.data.message || 'Erro ao atualizar dados')
      }
    } catch (err) {
      setError(err.response?.data?.message || err)
    } finally {
      setLoading(false)
    }
  }

  function geoStringToGoogleMapsLink(geo) {
    if (!geo) return null;
  
    geo = geo.trim();
  
    // 1️⃣ JÁ É DECIMAL: -22.3544365,-41.8216901
    if (/^-?\d+(\.\d+)?\s*,\s*-?\d+(\.\d+)?$/.test(geo)) {
      return `https://www.google.com/maps?q=${geo}`;
    }
  
    // 2️⃣ GRAUS + MINUTOS + SEGUNDOS
    const regexComSegundos =
      /(\d+)[°º](\d+)'([\d,]+)"([NS])\s+(\d+)[°º](\d+)'([\d,]+)"([LO])/;
  
    // 3️⃣ GRAUS + MINUTOS (decimal)
    const regexSemSegundos =
      /(\d+)[°º]([\d,]+)'([NS])\s+(\d+)[°º]([\d,]+)'([LO])/;
  
    let match = geo.match(regexComSegundos);
    let lat, lng;
  
    if (match) {
      let latG = +match[1];
      let latM = +match[2];
      let latS = parseFloat(match[3].replace(',', '.'));
      let latDir = match[4];
  
      let lngG = +match[5];
      let lngM = +match[6];
      let lngS = parseFloat(match[7].replace(',', '.'));
      let lngDir = match[8];
  
      lat = latG + latM / 60 + latS / 3600;
      lng = lngG + lngM / 60 + lngS / 3600;
  
      if (latDir === 'S') lat *= -1;
      if (lngDir === 'O') lng *= -1;
    } else {
      match = geo.match(regexSemSegundos);
      if (!match) return null;
  
      let latG = +match[1];
      let latM = parseFloat(match[2].replace(',', '.'));
      let latDir = match[3];
  
      let lngG = +match[4];
      let lngM = parseFloat(match[5].replace(',', '.'));
      let lngDir = match[6];
  
      lat = latG + latM / 60;
      lng = lngG + lngM / 60;
  
      if (latDir === 'S') lat *= -1;
      if (lngDir === 'O') lng *= -1;
    }
  
    return `https://www.google.com/maps?q=${lat},${lng}`;
  }

  // function geoStringToGoogleMapsLink(geo) {
  //   if (!geo) return null;

  //   geo = geo.trim();

  //   // FORMATO COM SEGUNDOS
  //   // 22º14'50,61"S 41°46'19,96"O
  //   const regexComSegundos =
  //     /(\d+)[°º](\d+)'([\d,]+)"([NS])\s+(\d+)[°º](\d+)'([\d,]+)"([LO])/;

  //   // FORMATO SEM SEGUNDOS (minuto decimal)
  //   // 22°11,011'S 41°45,672'O
  //   const regexSemSegundos =
  //     /(\d+)[°º]([\d,]+)'([NS])\s+(\d+)[°º]([\d,]+)'([LO])/;

  //   let match = geo.match(regexComSegundos);

  //   let lat, lng;

  //   if (match) {
  //     // 👉 COM SEGUNDOS
  //     let latG = +match[1];
  //     let latM = +match[2];
  //     let latS = parseFloat(match[3].replace(',', '.'));
  //     let latDir = match[4];

  //     let lngG = +match[5];
  //     let lngM = +match[6];
  //     let lngS = parseFloat(match[7].replace(',', '.'));
  //     let lngDir = match[8];

  //     lat = latG + latM / 60 + latS / 3600;
  //     lng = lngG + lngM / 60 + lngS / 3600;

  //     if (latDir === 'S') lat *= -1;
  //     if (lngDir === 'O') lng *= -1;
  //   } else {
  //     match = geo.match(regexSemSegundos);
  //     if (!match) return null;

  //     // 👉 SEM SEGUNDOS
  //     let latG = +match[1];
  //     let latM = parseFloat(match[2].replace(',', '.'));
  //     let latDir = match[3];

  //     let lngG = +match[4];
  //     let lngM = parseFloat(match[5].replace(',', '.'));
  //     let lngDir = match[6];

  //     lat = latG + latM / 60;
  //     lng = lngG + lngM / 60;

  //     if (latDir === 'S') lat *= -1;
  //     if (lngDir === 'O') lng *= -1;
  //   }

  //   return `https://www.google.com/maps?q=${lat},${lng}`;
  // }

  const handleSendEmailJS = (data) => {
    if (!emailDestinatario) {
      setError('Por favor, informe o e-mail de destino.');
      return;
    }

    const subject = `Dados do Produtor: ${data.nome}`;
    const body = `
Informações do Produtor:
-------------------------
Nome: ${data.nome}
CPF: ${data.cpf}
CAF: ${data.caf}
Data Inscrição CAF: ${data.data_inscricao_caf}
Data de Nascimento: ${data.dtnascimento}
Gênero: ${data.genero}
Apelido: ${data.apelido}
Cônjuge: ${data.nmconjuge}
Telefone: ${data.telefone}
Sítio/Propriedade: ${data.sitiopropriedade}
Localidade/Referência: ${data.localidadereferencia}
Ponto/Georeferência: ${data.pontogeoreferencia}
Área da Propriedade: ${data.areapropriedade}
Alimentos: ${selecionados.map(id => generosalimenticios.find(a => a.id === id)?.nome).join(', ')}
    `.trim();

    const mailtoLink = `mailto:${emailDestinatario}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoLink;
  };

  const handleSendEmailPHP = async (data) => {
    if (!emailDestinatario) {
      setError('Por favor, informe o e-mail de destino.');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess('');

    try {
      const response = await api.post('/produtor/send_email.php', {
        email_destino: emailDestinatario,
        producer_data: {
          ...data,
          alimentos: selecionados.map(id => generosalimenticios.find(a => a.id === id)?.nome)
        }
      });

      if (response.data.success) {
        setSuccess('E-mail enviado com sucesso via PHP!');
      } else {
        setError(response.data.message || 'Erro ao enviar e-mail via PHP.');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Erro ao conectar ao servidor para envio de e-mail.');
    } finally {
      setLoading(false);
    }
  };

  const handleSendWhatsApp = (data) => {
    if (!data.telefone) {
      setError('Produtor não possui telefone cadastrado.');
      return;
    }

    const cleanPhone = data.telefone.replace(/\D/g, '');
    const message = `
Olá ${data.nome}, segue suas informações de cadastro:
Site: ${window.location.origin}
CAF: ${data.caf}
Sítio: ${data.sitiopropriedade}
    `.trim();

    const waLink = `https://wa.me/55${cleanPhone}?text=${encodeURIComponent(message)}`;
    window.open(waLink, '_blank');
  };

  const loadAlimentos = async () => {
    setLoading(true);
    try {
      const response = await api.put('/alimentos/list.php', {
        // id: user.id,
        // nome: data.nome,
        // cpf: data.cpf,
        // caf: data.caf,
        // data_inscricao_caf: data.data_inscricao_caf
      })

      console.log(response.data.alimentos);

      if (response.data.success) {
        // const updatedUser = { ...user, ...data }
        console.log(response.data.alimentos);
        setGenerosalimenticios(response.data.alimentos)
        // updateUser(updatedUser)
        // setSuccess('Dados atualizados com sucesso!')
        // setTimeout(() => {
        //   navigate('/produtor')
        // }, 1500)
      } else {
        setError(response.data.message || 'Erro ao atualizar dados')
      }
    } catch (err) {
      setError(err.response?.data?.message || err)
    } finally {
      setLoading(false)
    }
  };

  const loadGrupos = async () => {
    try {
      const response = await api.put('/gruposassociacoes/list.php', {})

      if (response.data.success) {
        setGruposAssociacoes(response.data.grupos)
      } else {
        setError(response.data.message || 'Erro ao carregar grupos/associações')
      }
    } catch (err) {
      setError(err.response?.data?.message || err)
    }
  };

  useEffect(() => { loadAlimentos(); loadGrupos(); }, []);

  const handleChange = (event) => {
    const { value } = event.target;
    setSelecionados(typeof value === "string" ? value.split(",") : value);
  };

  function Row(props) {
    console.log(props);
    const { row } = props;
    const [open, setOpen] = React.useState(false);

    return (
      <React.Fragment>
        <TableRow onClick={() => handleEdit(row)} sx={{ '& > *': { borderBottom: 'unset' }, cursor: "pointer" }}>
          <TableCell>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={(e) => { e.stopPropagation(); setOpen(!open); }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row">
            {row.nome}
          </TableCell>
          <TableCell align="right">{row.cpf}</TableCell>
          <TableCell align="right">{!row.dtnascimento || row.dtnascimento === '0000-00-00' ? '' : format(parseISO(row.dtnascimento), 'dd/MM/yyyy')}</TableCell>
          <TableCell align="right">{row.genero}</TableCell>
          <TableCell align="right">{row.apelido}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                  Outros dados
                </Typography>
                <Table size="small" aria-label="purchases">
                  <TableHead>
                    <TableRow>
                      <TableCell>Data de Nascimento</TableCell>
                      <TableCell>Cônjuge</TableCell>
                      <TableCell align="right">Telefone</TableCell>
                      <TableCell align="right">Sítio/propriedade</TableCell>
                      <TableCell align="right">Localidade</TableCell>
                      <TableCell align="right">Geo referência</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* {row.history.map((historyRow) => ( */}
                    <TableRow>
                      <TableCell component="th" scope="row">
                        {!row.dtnascimento || row.dtnascimento === '0000-00-00' ? '' : format(parseISO(row.dtnascimento), 'dd/MM/yyyy')}
                      </TableCell>
                      <TableCell>{row.nmconjuge}</TableCell>
                      <TableCell align="right">{row.telefone}</TableCell>
                      <TableCell align="right">
                        {row.sitiopropriedade}
                      </TableCell>
                      <TableCell align="right">
                        {row.localidadereferencia}
                      </TableCell>
                      <TableCell align="right">
                        <a
                          href={geoStringToGoogleMapsLink(row.pontogeoreferencia)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {row.pontogeoreferencia}
                        </a>
                        {/* {row.pontogeoreferencia} */}
                      </TableCell>
                    </TableRow>
                    {/* ))} */}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  const Cadastro = () => {
    return (
      <Container sx={{ py: 3 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ textAlign: 'center', mb: 4 }}>
            <Person sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
            <Typography variant="h5" gutterBottom>
              Fornecedores
            </Typography>
          </Box>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
              {error}
            </Alert>
          )}

          {success && (
            <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
              {success}
            </Alert>
          )}



          <form className='admin-form' onSubmit={handleSubmit(onSubmit)}>
            {/* <div style={{display:'flex', flexDirection:'row'}}> */}
            <Grid container spacing={3}>
              {/* <div className="form-row col"> */}
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  // className='form-control'
                  className='col'
                  label="Nome Completo"
                  margin="normal"
                  {...register('nome', {
                    // required: 'Nome é obrigatório',
                    minLength: {
                      value: 3,
                      message: 'Nome deve ter no mínimo 3 caracteres'
                    }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth

                  // className='form-control'
                  label="Data de Nascimento"
                  type="date"
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  {...register('dtnascimento', {
                    // required: 'Data de inscrição do CAF é obrigatória'
                  })}
                // error={!!errors.dtnascimento}
                // helperText={
                //   errors.dtnascimento?.message ||
                //   'Esta data deve ser atualizada a cada 3 anos'
                // }
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  // className='form-control'
                  label="CPF"
                  margin="normal"
                  {...register('cpf', {
                    // required: 'CPF é obrigatório',
                    // pattern: {
                    //   value: /^\d{14}$/,
                    //   message: 'CPF deve conter 11 dígitos'
                    // }
                  })}
                  error={!!errors.cpf}
                  helperText={errors.cpf?.message}
                  placeholder="00000000000"
                />
              </Grid>
              {/* </div> */}

              {/* <div className="form-row"> */}
              {/* <div style={{ marginBottom: 16 }}> */}
              <Grid item xs={12} md={4}>

                <TextField
                  fullWidth
                  // className='form-control'
                  label="CAF (Cadastro da Agricultura Familiar)"
                  margin="normal"
                  {...register('caf', {
                    // required: 'CAF é obrigatório'
                  })}
                  error={!!errors.caf}
                  helperText={errors.caf?.message}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth

                  // className='form-control'
                  label="Data de Inscrição do CAF"
                  type="date"
                  margin="normal"
                  InputLabelProps={{
                    shrink: true
                  }}
                  {...register('data_inscricao_caf', {
                    // required: 'Data de inscrição do CAF é obrigatória'
                  })}
                  error={!!errors.data_inscricao_caf}
                  helperText={
                    errors.data_inscricao_caf?.message ||
                    'Esta data deve ser atualizada a cada 3 anos'
                  }
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  select
                  label="Sexo"
                  fullWidth
                  margin="normal"
                  {...register('genero', {
                    // required: 'CAF é obrigatório'
                  })}
                // onChange={(e) => setSexo(e.target.value)}
                >
                  <MenuItem value="M">Masculino</MenuItem>
                  <MenuItem value="F">Feminino</MenuItem>
                </TextField>
              </Grid>
              {/* </div> */}
              {/* </div> */}

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  // className='form-control'
                  className='col'
                  label="Apelido"
                  margin="normal"
                  {...register('apelido', {
                    // required: 'Nome é obrigatório',
                    minLength: {
                      value: 3,
                      message: 'Apelido deve ter no mínimo 3 caracteres'
                    }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  // className='form-control'
                  className='col'
                  label="Cônjuge"
                  margin="normal"
                  {...register('nmconjuge', {
                    // required: 'Nome é obrigatório',
                    minLength: {
                      value: 3,
                      message: 'Cônjuge deve ter no mínimo 3 caracteres'
                    }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  // className='form-control'
                  className='col'
                  label="Telefone"
                  margin="normal"
                  {...register('telefone', {
                    // required: 'Nome é obrigatório',
                    // minLength: {
                    //   value: 3,
                    //   message: 'Cônjuge deve ter no mínimo 3 caracteres'
                    // }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  // className='form-control'
                  className='col'
                  label="Sítio/propriedade"
                  margin="normal"
                  {...register('sitiopropriedade', {
                    // required: 'Nome é obrigatório',
                    // minLength: {
                    //   value: 3,
                    //   message: 'Cônjuge deve ter no mínimo 3 caracteres'
                    // }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  // className='form-control'
                  className='col'
                  label="Localidade/referência"
                  margin="normal"
                  {...register('localidadereferencia', {
                    // required: 'Nome é obrigatório',
                    // minLength: {
                    //   value: 3,
                    //   message: 'Cônjuge deve ter no mínimo 3 caracteres'
                    // }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  // className='form-control'
                  className='col'
                  label="Ponto/georeferência"
                  margin="normal"
                  {...register('pontogeoreferencia', {
                    // required: 'Nome é obrigatório',
                    // minLength: {
                    //   value: 3,
                    //   message: 'Cônjuge deve ter no mínimo 3 caracteres'
                    // }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  // className='form-control'
                  className='col'
                  label="Área da propriedade"
                  margin="normal"
                  {...register('areapropriedade', {
                    // required: 'Nome é obrigatório',
                    // minLength: {
                    //   value: 3,
                    //   message: 'Cônjuge deve ter no mínimo 3 caracteres'
                    // }
                  })}
                  error={!!errors.nome}
                  helperText={errors.nome?.message}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Autocomplete
                  multiple
                  disableCloseOnSelect
                  options={generosalimenticios}
                  value={generosalimenticios.filter((opt) => selecionados.includes(opt.id))}
                  isOptionEqualToValue={(option, value) => option.id === value.id}
                  getOptionLabel={(option) => option.nome}
                  onChange={(event, newValue) => {
                    setSelecionados(newValue.map(item => item.id));
                  }}
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox checked={selected} style={{ marginRight: 8 }} />
                      {option.nome}
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Gêneros Alimentícios"
                      placeholder="Selecione"
                      margin="normal"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  select
                  label="Grupo/Associação"
                  fullWidth
                  margin="normal"
                  {...register('idgrupo')}
                >
                  <MenuItem value="">Nenhum</MenuItem>
                  {gruposAssociacoes.map((grupo) => (
                    <MenuItem key={grupo.id} value={grupo.id}>
                      {grupo.nome}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="E-mail de Destino"
                  margin="normal"
                  value={emailDestinatario}
                  onChange={(e) => setEmailDestinatario(e.target.value)}
                  placeholder="exemplo@email.com"
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, mt: 3 }}>
                  {(mode != 'create' && mode != 'edit') ? (
                    <Button
                      onClick={() => setMode('create')}
                      variant="contained"
                      size="large"
                      startIcon={<Save />}
                      disabled={loading}
                    >
                      {'Novo'}
                    </Button>
                  ) : (
                    <>
                      <Button
                        type="submit"
                        variant="contained"
                        size="large"
                        startIcon={<Save />}
                        disabled={loading}
                      >
                        {'Salvar'}
                      </Button>

                      <Button
                        variant="contained"
                        size="large"
                        color="info"
                        onClick={handleSubmit(handleSendEmailPHP)}
                        startIcon={<Email />}
                        disabled={loading}
                      >
                        Email (PHP)
                      </Button>

                      <Button
                        variant="contained"
                        size="large"
                        sx={{ backgroundColor: '#25D366', '&:hover': { backgroundColor: '#128C7E' } }}
                        onClick={handleSubmit(handleSendWhatsApp)}
                        startIcon={<WhatsApp />}
                        disabled={loading}
                      >
                        WhatsApp
                      </Button>
                    </>
                  )}

                  <Button
                    type="button"
                    variant="contained"
                    size="large"
                    onClick={() => setMode('Busca')}
                    sx={{ backgroundColor: '#7469ea' }}
                    startIcon={mode == 'create' ? <KeyboardReturnIcon /> : <Search />}
                    disabled={loading}
                  >
                    {'Voltar'}
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>

          {rows && mode !== 'create' && mode !== 'edit' && <React.Fragment>
            <TableContainer component={Paper}>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell>Nome</TableCell>
                    <TableCell align="right">CPF</TableCell>
                    <TableCell align="right">Nascimento</TableCell>
                    <TableCell align="right">Gênero</TableCell>
                    <TableCell align="right">Apelido</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <Row key={row.name} row={row} />
                    ))}
                </TableBody>
                {/* <TableBody>
                    {rows.map((row) => (
                      <Row key={row.name} row={row} />
                    ))}
                  </TableBody> */}
              </Table>
            </TableContainer>

            <TablePagination
              component="div"
              count={rows.length}
              page={page}
              onPageChange={(e, newPage) => setPage(newPage)}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={(e) => {
                setRowsPerPage(parseInt(e.target.value, 10));
                setPage(0);
              }}
              rowsPerPageOptions={[5, 10, 25]}
              labelRowsPerPage="Linhas por página"
            />

          </React.Fragment>}

          {/* <form onSubmit={handleSubmit(onSubmit)}>
            <TextField
              fullWidth
              label="Nome Completo"
              margin="normal"
              {...register('nome', {
                required: 'Nome é obrigatório',
                minLength: {
                  value: 3,
                  message: 'Nome deve ter no mínimo 3 caracteres'
                }
              })}
              error={!!errors.nome}
              helperText={errors.nome?.message}
            />

            <TextField
              fullWidth
              label="CPF"
              margin="normal"
              {...register('cpf', {
                required: 'CPF é obrigatório',
                pattern: {
                  value: /^\d{11}$/,
                  message: 'CPF deve conter 11 dígitos'
                }
              })}
              error={!!errors.cpf}
              helperText={errors.cpf?.message}
              placeholder="00000000000"
            />

            <TextField
              fullWidth
              label="CAF (Cadastro da Agricultura Familiar)"
              margin="normal"
              {...register('caf', {
                required: 'CAF é obrigatório'
              })}
              error={!!errors.caf}
              helperText={errors.caf?.message}
            />

            <TextField
              fullWidth
              label="Data de Inscrição do CAF"
              type="date"
              margin="normal"
              InputLabelProps={{
                shrink: true
              }}
              {...register('data_inscricao_caf', {
                required: 'Data de inscrição do CAF é obrigatória'
              })}
              error={!!errors.data_inscricao_caf}
              helperText={
                errors.data_inscricao_caf?.message ||
                'Esta data deve ser atualizada a cada 3 anos'
              }
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{ mt: 3 }}
              startIcon={<Save />}
              disabled={loading}
            >
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </Button>
          </form> */}
        </Paper>
      </Container>
    )
  }


  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={() => navigate('/produtor')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <Person sx={{ mr: 2 }} />
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Meu Perfil
          </Typography>
        </Toolbar>
      </AppBar>

      {mode == 'create' || mode == 'edit'
        ?
        <Cadastro item={itemEdit} />
        // <Formuario item={itemEdit} />
        :
        <Container sx={{ py: 3 }}>
          <Paper elevation={3} sx={{ p: 4}}>
            <Box sx={{ textAlign: 'center', mb: 4 }}>
              <Person sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
              <Typography variant="h5" gutterBottom>
                Fornecedores
              </Typography>
            </Box>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            {success && (
              <Alert severity="success" sx={{ mb: 2 }} onClose={() => setSuccess('')}>
                {success}
              </Alert>
            )}



            <form className='admin-form' onSubmit={handleSubmit(onSubmitBusca)}>
              {/* <div style={{display:'flex', flexDirection:'row'}}> */}
              <Grid container spacing={3}>
                {/* <div className="form-row col"> */}
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    // className='form-control'
                    className='col'
                    label="Nome Completo"
                    margin="normal"
                    {...register('nome', {
                      // required: 'Nome é obrigatório',
                      minLength: {
                        value: 3,
                        message: 'Nome deve ter no mínimo 3 caracteres'
                      }
                    })}
                    error={!!errors.nome}
                    helperText={errors.nome?.message}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    // className='form-control'
                    label="CPF"
                    margin="normal"
                    {...register('cpf', {
                      // required: 'CPF é obrigatório',
                      pattern: {
                        value: /^\d{14}$/,
                        message: 'CPF deve conter 14 dígitos'
                      }
                    })}
                    error={!!errors.cpf}
                    helperText={errors.cpf?.message}
                    placeholder="00000000000"
                  />
                </Grid>
                {/* </div> */}

                {/* <div className="form-row"> */}
                {/* <div style={{ marginBottom: 16 }}> */}
                <Grid item xs={12} md={4}>

                  <TextField
                    fullWidth
                    // className='form-control'
                    label="CAF (Cadastro da Agricultura Familiar)"
                    margin="normal"
                    {...register('caf', {
                      // required: 'CAF é obrigatório'
                    })}
                    error={!!errors.caf}
                    helperText={errors.caf?.message}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth

                    // className='form-control'
                    label="Data de Inscrição do CAF"
                    type="date"
                    margin="normal"
                    InputLabelProps={{
                      shrink: true
                    }}
                    {...register('data_inscricao_caf', {
                      // required: 'Data de inscrição do CAF é obrigatória'
                    })}
                    error={!!errors.data_inscricao_caf}
                    helperText={
                      errors.data_inscricao_caf?.message ||
                      'Esta data deve ser atualizada a cada 3 anos'
                    }
                  />
                </Grid>
                {/* </div> */}
                {/* </div> */}

                <Grid item xs={12} md={12}>

                  {mode != 'create' ? (<Button
                    //   type="submit"
                    //   fullWidth
                    onClick={() => setMode('create')}
                    variant="contained"
                    size="large"
                    sx={{ mt: 3 }}
                    startIcon={<Save />}
                    disabled={loading}
                  >
                    {'Novo'}
                    {/* {loading ? 'Salvando...' : 'Salvar Alterações'} */}
                  </Button>) :

                    (<Button
                      // type="submit"
                      //   fullWidth
                      onClick={() => setMode('create')}
                      variant="contained"
                      size="large"
                      sx={{ mt: 3 }}
                      startIcon={<Save />}
                      disabled={loading}
                    >
                      {'Salvar'}
                      {/* {loading ? 'Salvando...' : 'Salvar Alterações'} */}
                    </Button>)
                  }

                  <Button
                    type="submit"
                    //   fullWidth
                    variant="contained"
                    size="large"
                    sx={{ mt: 3, marginLeft: 2, backgroundColor: '#ccdb00' }}
                    startIcon={mode == 'create' ? <KeyboardReturnIcon /> : <Search />}
                    disabled={loading}
                  >
                    {mode == 'create' ? 'Voltar' : 'Buscar'}
                    {/* {loading ? 'Salvando...' : 'Salvar Alterações'} */}
                  </Button>
                </Grid>
              </Grid>
            </form>

            {rows && mode !== 'create' && mode !== 'edit' && <React.Fragment>
              <TableContainer component={Paper}>
                <Table aria-label="collapsible table">
                  <TableHead>
                    <TableRow>
                      <TableCell />
                      <TableCell>Nome</TableCell>
                      <TableCell align="right">CPF</TableCell>
                      <TableCell align="right">Nascimento</TableCell>
                      <TableCell align="right">Gênero</TableCell>
                      <TableCell align="right">Apelido</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {rows
                      .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                      .map((row) => (
                        <Row key={row.name} row={row} />
                      ))}
                  </TableBody>
                  {/* <TableBody>
                    {rows.map((row) => (
                      <Row key={row.name} row={row} />
                    ))}
                  </TableBody> */}
                </Table>
              </TableContainer>

              <TablePagination
                component="div"
                count={rows.length}
                page={page}
                onPageChange={(e, newPage) => setPage(newPage)}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={(e) => {
                  setRowsPerPage(parseInt(e.target.value, 10));
                  setPage(0);
                }}
                rowsPerPageOptions={[5, 10, 25]}
                labelRowsPerPage="Linhas por página"
              />

            </React.Fragment>}

            {/* <form onSubmit={handleSubmit(onSubmit)}>
            <TextField
              fullWidth
              label="Nome Completo"
              margin="normal"
              {...register('nome', {
                required: 'Nome é obrigatório',
                minLength: {
                  value: 3,
                  message: 'Nome deve ter no mínimo 3 caracteres'
                }
              })}
              error={!!errors.nome}
              helperText={errors.nome?.message}
            />

            <TextField
              fullWidth
              label="CPF"
              margin="normal"
              {...register('cpf', {
                required: 'CPF é obrigatório',
                pattern: {
                  value: /^\d{11}$/,
                  message: 'CPF deve conter 11 dígitos'
                }
              })}
              error={!!errors.cpf}
              helperText={errors.cpf?.message}
              placeholder="00000000000"
            />

            <TextField
              fullWidth
              label="CAF (Cadastro da Agricultura Familiar)"
              margin="normal"
              {...register('caf', {
                required: 'CAF é obrigatório'
              })}
              error={!!errors.caf}
              helperText={errors.caf?.message}
            />

            <TextField
              fullWidth
              label="Data de Inscrição do CAF"
              type="date"
              margin="normal"
              InputLabelProps={{
                shrink: true
              }}
              {...register('data_inscricao_caf', {
                required: 'Data de inscrição do CAF é obrigatória'
              })}
              error={!!errors.data_inscricao_caf}
              helperText={
                errors.data_inscricao_caf?.message ||
                'Esta data deve ser atualizada a cada 3 anos'
              }
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              sx={{ mt: 3 }}
              startIcon={<Save />}
              disabled={loading}
            >
              {loading ? 'Salvando...' : 'Salvar Alterações'}
            </Button>
          </form> */}
          </Paper>
        </Container>
      }
    </Box>
  )
}

export default Formprodutor

